import React, { useEffect } from "react";
import "./app.css";
import { useSelector } from "react-redux";
import type { RootState } from '../stores/store';
import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "../pages/login/login";
import Navbar from "../components/navbar/navbar";
import HomePage from "../pages/home/home";
import ReportsPage from "../pages/reports/reports";
import SnagBoard from "../pages/board/SnagBoard";
import Settings from "../pages/settings/settings";
import SitesViewer from "../pages/sites-viewer/SitesViewer";
import UserGroups from "../pages/user-groups/user-groups";
import ShiftsPage from "../pages/shifts/ShiftsPage";
import OperationsPage from "../pages/operations/OperationsPage";
import { startHealthCheck, stopHealthCheck } from "../services/healthCheckService";

function App() {
  const isAuthenticated = useSelector(
    (state: RootState) => state.auth.isAuthenticated
  );

  // Initialize health check when app mounts
  useEffect(() => {
    startHealthCheck();

    return () => {
      stopHealthCheck();
    };
  }, []);
  return (
    <div>
       {isAuthenticated ? (<Navbar />) : null}
      <Routes>
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/home" /> : <LoginPage />}
      />
      {isAuthenticated ? (
        <>
          <Route path="/home" element={<HomePage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/snag-board" element={<SnagBoard />} />
          <Route path="/sitespage" element={<SitesViewer />} />
          <Route path="/shifts" element={<ShiftsPage />} />
          <Route path="/operations" element={<OperationsPage />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/user-groups" element={<UserGroups />} />
        </>
      ) : (
        <Route path="*" element={<Navigate to="/login" />} />
      )}
    </Routes>
    </div>
    

  );
}

export default App;
